import React,{useState,useEffect} from 'react'
import SubHeader from '../../../layout/components/SubHeader'
import PatientInfoCard from './PatientInfoCard'
import PatientTabs from './PatientTabs'
import patientService from '../../../../services/patient.service';
import { useParams } from 'react-router-dom';
import { useEyeconxStore } from '../../../../store/eyeconxStore';
import Loading from '../../../common/Loading';
import { useNavigate } from 'react-router-dom';

function Patient() {

  const [patient, setPatient] = useState(null);
  const { patientId } = useParams();
  const clinicId = useEyeconxStore((state) => state.user.clinicId);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  
  useEffect(() => {
    getPatient();
  }, []);
  
  const getPatient = async () => {

    try{

       const response = await patientService.getPatientById(clinicId, patientId);
       setPatient(response.data);
       setLoading(false);
    } catch (error) {
      console.error('Error fetching patient:', error);
      setLoading(false);
    } finally {
      // Optionally set loading state to false here
      setLoading(false);
    }
  };
  
  if (loading) {
    return <Loading />;
  }
  const handleBack = () => {
    navigate(-1);
  };
  return (
    <>
        <SubHeader title="Patient Details" description={"Patient Details Page and Communication"} >
            <button className="btn btn-outline-secondary" onClick={handleBack}>
               <i className="bi bi-arrow-left me-2"></i> Back
            </button>
        </SubHeader>
        {patient &&  <>
            <PatientInfoCard patient={patient} /> 
            <PatientTabs patient={patient} />
        </>
        }
    </>
  )
}

export default Patient